import { render, staticRenderFns } from "./OrganizerDropdown.vue?vue&type=template&id=4601e36b"
import script from "./OrganizerDropdown.vue?vue&type=script&lang=js"
export * from "./OrganizerDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports